import React, { useState, useTransition } from 'react';

import classNames from 'classnames';

import { Text } from '../shared/Text/Text';

interface TabSwitcherProps {
  tabs: { [key: string]: React.ReactNode };
  tabKeys: { label: string; key: string }[];
  className?: string;
  // Supply both to own the selection; left out, the switcher keeps track of it itself.
  activeKey?: string;
  onTabChange?: (tab: string) => void;
}

const TabSwitcher = ({ tabs, tabKeys, className, activeKey, onTabChange }: TabSwitcherProps) => {
  const [internalTab, setInternalTab] = useState<string>(tabKeys[0].key);
  const [isPending, startTransition] = useTransition();

  const activeTab = activeKey ?? internalTab;

  const handleTabChange = (tab: string) => {
    startTransition(() => {
      setInternalTab(tab);
      onTabChange?.(tab);
    });
  };

  return (
    <div>
      <div className={classNames('flex justify-start space-x-2 mb-8 gap-24', className)}>
        {tabKeys.map((tab) => (
          <button
            key={tab.key}
            onClick={() => handleTabChange(tab.key)}
            className={`py-2 transition-all ${
              activeTab === tab.key
                ? 'border-blue-500 bg-blue-500 text-primary-50 border-b-2 border-primary-50'
                : 'border-gray-300 bg-gray-100 text-black'
            }`}
            disabled={isPending}
          >
            <Text.Normal weight="bold">{tab.label}</Text.Normal>
          </button>
        ))}
      </div>
      {tabs[activeTab]}
    </div>
  );
};

export default TabSwitcher;
